__turbopack_context__.v({
  "className": "roboto_159c740f-module__jjVddW__className",
  "variable": "roboto_159c740f-module__jjVddW__variable",
});
